import { iconCredit, iconCalculator, iconPreAprobador } from '../defaultValues';

const data = {
    role_5eb7d7698ed24f21b8afc4653c79abe6: [
        {
            id: 'solicitudes-credito',
            icon: iconCredit,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        {
            id: 'pre-aprobador',
            icon: iconPreAprobador,
            label: 'Pre-aprobador',
            to: '/app/pre-aprobador',
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
        },
    ],
};
export default data;
